// Chakra imports
import {
  Button,
  Flex,
  Stack,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
// Custom components
import useAxios from "axios-hooks";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import React, { useState, useEffect } from "react";
import Loading from "components/Layout/Loading";
import { TablePagination } from "@trendmicro/react-paginations";
import { initialFilter } from "utils/constant";
import { ROOT_API } from "utils/constant";
import { API_ROUTES } from "utils/constant";
import AddSMTPServerDialog from "components/SMTPServer/AddSMTPServerDialog";
import SMTPRow from "components/SMTPServer/SMTPRow";

const defaultFilter = {
  ...initialFilter,
};
function SMTPServer() {
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const [filter, setFilter] = useState(defaultFilter);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [{ data, loading, error }, refetch] = useAxios({
    url: ROOT_API + API_ROUTES.SMTP_SERVER,
    params: filter,
  });

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card bg="#fff" overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader p="6px 0px 22px 0px">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            SMTP Server
          </Text>
          <Button variant="primary" maxH="30px" m="10px" onClick={onOpen}>
            Add
          </Button>
        </CardHeader>
        <CardBody>
          {loading ? (
            <Loading />
          ) : (
            <Stack overflow={"auto"}>
              <Table variant="simple" color={textColor}>
                <Thead>
                  <Tr my=".8rem" pl="0px" color="gray.400">
                    <Th borderColor={borderColor} color="gray.400">
                      Brand
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Port
                    </Th>
                    {/* <Th borderColor={borderColor} color="gray.400">
                      Secure
                    </Th> */}
                    <Th borderColor={borderColor} color="gray.400">
                      User Email
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      User Password
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Total Email Sent
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Email Sent In Day
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Reach the Limit
                    </Th>
                    <Th
                      minWidth="100px"
                      borderColor={borderColor}
                      color="gray.400"
                    >
                      Google
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Status
                    </Th>
                    <Th borderColor={borderColor} color="gray.400">
                      Backup Email
                    </Th>
                    <Th borderColor={borderColor}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data?.data?.length
                    ? data.data.map((row, index, arr) => {
                        return (
                          <SMTPRow
                            key={index}
                            setting={row}
                            refetch={refetch}
                            isLast={index === arr.length - 1 ? true : false}
                          />
                        );
                      })
                    : ""}
                </Tbody>
              </Table>
              <Flex justifyContent="flex-end">
                <TablePagination
                  type="full"
                  page={data?.pagination?.page}
                  pageLength={data?.pagination?.pageSize}
                  totalRecords={data?.pagination?.count}
                  onPageChange={({ page, pageLength }) => {
                    console.log(page);
                    setFilter({
                      ...filter,
                      pageSize: pageLength,
                      pageIndex: page - 1,
                    });
                  }}
                  prevPageRenderer={() => <i className="fa fa-angle-left" />}
                  nextPageRenderer={() => <i className="fa fa-angle-right" />}
                />
              </Flex>
            </Stack>
          )}
        </CardBody>
      </Card>
      <AddSMTPServerDialog
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        fetchData={refetch}
      />
    </Flex>
  );
}

export default SMTPServer;
